export const dragHandleTokens = {
  'drag-color': 'var(--dp-color-border-strong)',
  'drag-hover-color': 'var(--dp-color-primary)',
  'drag-size': '16px',
  'drag-padding': 'var(--dp-spacing-xs)',
  'drag-cursor': 'grab',
  'drag-active-cursor': 'grabbing',
  'drag-opacity-dragging': '0.8',
} as const;
